import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import { BusinessModel } from '../../../@models';
import { NameTable } from '../../../@models/erp/finishedProduct';

@Component({
  selector: 'ngx-form-multi-select',
  templateUrl: './form-multi-select.component.html',
  styleUrls: ['./form-multi-select.component.scss'],
})
export class FormMultiSelectComponent {

  @Input() multiple = true;
  @Input() value: string[];
  @Input() options: { id: string, name: string }[] = []
  @Input() title = '';
  @Input() mode: string;
  @Input() checkbox = false;
  @Input() businessId = null;
  @Input() placeholder = null;
  // @Input() businesses: BusinessModel[];
  // @Input() finishedProductNames: NameTable[];
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  combinedShipment = null;

  constructor(public data: SharedDataService) { }

  getLines(item: string) {
    return item.split('||');
  }

  updateValue(event) {
    this.valueChange.emit(event);
  }

  // productSelected(event: NameTable) {
  //   this.value = [...this.value, event.id];
  //   this.valueChange.emit(this.value);
  // }

  productSelected(event: any) {
    if (this.multiple) {
      // console.log('multiple', this.value, event);
      this.value = Array.isArray(event) ? [...this.value, ...event.map(m => m._id)] : [event._id];
    } else {
      // console.log('!multiple', this.value, event);
      this.value = [...(this.value || []), event._id];
    }
    this.valueChange.emit(this.value);
  }

  addSelection(event: any) {
    if (this.multiple) {
      this.value = Array.isArray(event) ? event : [event];
    } else {
      this.value = [...(this.value || []), event];
    }
    this.valueChange.emit(this.value);
  }

}
